define('app/components/race/rankChartDirective.js',["https://cdnjs.cloudflare.com/ajax/libs/d3/3.5.12/d3.js"], function (d3) {
	function rankChartDirective() {
		return {
			restrict: 'E',
			replace: false,
			// scope: {data: '=chartData'},
			link: function(scope, element, attrs) {
				

				scope.$watchCollection('rankData', function(data) {
					element.html("");
					if(data === undefined || data === "" || scope.rankChart.year === undefined || scope.rankChart.year === null) {
						element.html("<div class='placeholder'><img ng-src='assets/placeholder.jpg'></div>");
						return;
					}
					var lapData = data.lapData;
					//var driverData = data.driverData;
					//var pitstopData = data.pitstopData;
				
					//Initial setup
					var margin = {top: 20, right: 80, bottom: 60, left: 150},
					    width = 960 - margin.left - margin.right,
					    height = 500 - margin.top - margin.bottom;

					var svg = d3.select(element[0]).append("svg")
						.attr("viewBox", "0 0 " + Number(width+margin.left+margin.right) + " " + Number(height+margin.top+margin.bottom))
						.attr("preserveAspectRatio", "xMinYMin meet")
					  .append("g")
					  	.attr("transform", "translate(" + margin.left + "," + margin.top + ")");	

					var lapDataNest = d3.nest()
						.key(function(d){ return d[1].qText })
						.entries(lapData);
					//Domain, range, and axis stuff
					var x = d3.scale.linear()
						.domain([0, d3.max(lapData, function(row){ return row[0].qNum }) ])
						.range([0, width]);
					var y = d3.scale.linear()
						.domain([1, d3.max(lapData, function(row){ return row[2].qNum }) ])
						.range([0, height]);
					var xAxis = d3.svg.axis()
						.scale(x)
						.orient("bottom");
					var yAxis = d3.svg.axis()
						.scale(y)
						.orient("left")
						.ticks(lapDataNest.length);
						//.tickValues(lapData.map(function (d,i) {return d.key}))
					var yAxis2 = d3.svg.axis()
						.scale(y)
						.orient("right")
						.ticks(lapDataNest.length);
					svg.append("g")
						.attr("class", "x axis")
						.attr("transform", "translate(0," + height + ")")
						.call(xAxis);
					svg.append("g")
						.attr("class", "y axis")
						.call(yAxis)
						.selectAll("text")
						.text(function (d,i) {return lapData[i][1].qText;})
						//.style("text-anchor", "start")
						//.attr("x", "-" + margin.left);
					svg.append("g")
						.attr("class", "y2 axis")
						.attr("transform", "translate(" + width + ",0)")
						.call(yAxis2);
						//.selectAll("text")
						//.text(function (d,i) {return lapData[lapData.length - lapDataNest.length + i][1].qText;})

					//x-axis title
					svg.append("text")
						.attr("x", width/2)
						.attr("dx", "-.4em")
						.attr("y", height+60)
						.attr("text-anchor", "middle")
						.text("LAP");

					svg.append("text")
						.attr("x", height/2)
						//.attr("dy", "-.4em")
						.attr("y", -width-50)
						.attr("transform", "rotate(90)")
						.attr("text-anchor", "middle")
						.text("POSITION");



					//Line drawing stuff
					var colors = d3.scale.category10();
					var lineFunction = 
						d3.svg.line()
							//.interpolate('cardinal')
					    	.x(function(d) { return x(d[0].qNum); })
					    	.y(function(d) { return y(d[2].qNum); });
					
					// var lapDataNest = d3.nest()
					// 	.key(function(d){ return d[1].qText })
					// 	.entries(lapData);

					// var driverDataNest = d3.nest()
					// 	.key(function(d){ return d[0].qText })
					// 	.entries(driverData);

					// var pitstopDataNest = d3.nest()
					// 	.key(function(d){ return d[1].qText })
					// 	.entries(pitstopData);

					lapDataNest.forEach(function(d,i) {

						var path = svg.append("path")
							.attr("class", "line")
							.attr("stroke", colors(i))
							.attr("stroke-width", 2)
							.attr("d", lineFunction(d.values))
							.on("mouseover", function() { 
								d3.select(this)
									.transition()
									.duration(50)
									.style("stroke-width", 5);
							})
							.on("mouseout", function() { 
								d3.select(this)
									.transition()
									.duration(100)
									.style("stroke-width", 2);
							});

						// //Finish status
						// if(driverDataNest[i].values[0][1].qText !== "Finished") {
						// 	var status = svg.append("circle")
						// 		.attr("r", 4)
						// 		.attr("cx", x(d.values.length-1))
						// 		.attr("cy", y(d.values[d.values.length-1][2].qNum))
						// 		.attr("fill", "gray");
						// }
						
						// //Fastest lap
						// var status = svg.append("circle")
						// 	.attr("r", 4)
						// 	.attr("cx", x(driverDataNest[i].values[0][2].qText))
						// 	.attr("cy", y( driverDataNest[i].values[0][4].qText ))
						// 	.attr("fill", "green");
					});

					var curtain = svg.append('rect')
					    .attr('x', -1 * width)
					    .attr('y', -1 * height)
					    .attr('height', height+2)
					    .attr('width', width)
					    .attr('class', 'curtain')
					    .attr('transform', 'rotate(180)')
					    .style('fill', '#ffffff')
					    .transition()
					    .duration(12000)
					    .ease('linear')
					    .attr('width', 0);
				});

			}
		}
	}

  	return rankChartDirective;
});
